import React from "react";
import Grid from "@material-ui/core/Grid";
import prod2 from "../../images/app3.png";
import { NavLink } from "react-router-dom";

export default function ExoploreNetworkBanner() {
  return (
    <div>
      <div
        // maxWidth={12}
        className="serviceContainer"
        id="ExploreBannerContainer ExploreBannerContainer--mod"
      >
        <div className="gridSection gridSection--mmod">
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
            direction="row"
          >
            <Grid
              id="complementaryServices_link"
              className="hoverEffect"
              item
              md={13}
              sm={14}
              xs={16}
            >
              <NavLink to="/edge-ai-network">
                <img src={prod2} alt="" />
                <h4>Micro-Ecosystem Network Framework</h4>
              </NavLink>
            </Grid>
           {/*  <Grid
              id="complementaryServices_link"
              className="hoverEffect"
              item
              md={3}
              sm={4}
              xs={6}
            >
              <NavLink to="/GBR-Network">
                <img src={prod2} alt="" />
                <h4>GBR Network</h4>
              </NavLink>
            </Grid> */}

            <Grid
              id="complementaryServices_link"
              className="hoverEffect"
              item
              md={13}
              sm={14}
              xs={16}
            >
              <NavLink to="/ABN">
                <img src={prod2} alt="" />
                <h4>Ecosystem Network Framework</h4>
              </NavLink>
            </Grid>

 
          </Grid>
        </div>
      </div>
    </div>
  );
}
